import axios from 'axios';


export default {
    getTheme: (url) => {
        if (!url) return Promise.reject("id is not supported");
        return axios.get(url);
    },
    exportTheme: (theme) => {
        return axios.post("/api/themes/export", theme, {
            responseType: 'blob'
        });
    },
    deleteTheme: (id) => {
        return axios.delete("/api/themes/delete/" + id);
    },
    getThemes: () => {
        return axios.get("/api/themes");
    },
    duplicateTheme: (id) => {
        return axios.post("/api/themes/duplicate/" + id);
    }
}

